import React from "react";
import Navbar from "./Navbar";
import BookAppointment from "./BookAppointment";
import Contact from "./Contact";
function BookAppointmentpage()
{
    return(
        <>
        <Navbar/>
        <BookAppointment/>
        <Contact/>
        </>
    )
}
export default BookAppointmentpage;